export default [
  {
    path: 'certificate',
    name: 'certificate',
    component: () => import('@/views/pages/certificate/Index.vue'),
    meta: {
      pageTitle: 'Certificate',
      breadcrumb: [
        {
          text: 'Certificate',
          active: true,
        },
      ],
      resource: 'Certificate',
    },
  },
  {
    path: 'certificate/:id',
    name: 'certificate-view',
    component: () => import('@/views/pages/certificate/type/Index.vue'),
    meta: {
      pageTitle: 'Certificate',
      breadcrumb: [
        {
          to: { name: 'certificate' },
          text: 'Certificate',
          active: false,
        },
        {
          text: 'Sertifikat nomi',
          active: true,
        },
      ],
      resource: 'Certificate',
    },
  },
]
